<template>
    <div class="white_bg">

        <div class="body clearfix" :style="'height:'+height+'px'">
<!--            <div class="fl leftSideBar white_bg h100p hiddenScrollbar" :style="'width: 23.2%; overflow-y:auto;'">-->
<!--                <categorySidebar @changeCategory ="onChangeCategory"/>-->
<!--            </div>-->

            <div class="rightInfo centerRegion fr white_bg h100p hiddenScrollbar" data-style="width: 75.73%; overflow-y:auto;">

                <div class="inner" style="padding: 16px 18px 0 9px;">
<!--                    <div class="">-->
<!--                        <adModule version="4" :type="56" :itemCount="1"/>-->
<!--                    </div>-->

                    <div class="datumList marginT12">
                        <div class="datumItem" v-for="dataItem in dataList" :key="dataItem.id"
                             @click="viewItem(dataItem)">
                            <div class="flexLayout">
                                <div style="width: 76px; margin-right: 6px;">
                                    <div class="imageArea roundBorder8 hiddenOverflow"
                                         style="width: 100%; height: 76px;">
                                        <img class="fullSpace" :src="dataItem.coverImg"/>
                                    </div>
                                </div>
                                <div class="flexItem">
                                    <div class="titleArea maxHeightTwoLine hiddenOverflow"
                                         style="padding-top: 9px; line-height: 1.3em; height: 2.6em; text-overflow: ellipsis">
                                        {{dataItem.title}}
                                        <span v-if="(isDebug || mode === 'professional') && dataItem.isPay" class="green">
                                            [已支付]
                                        </span>

                                        <span class="datumTypeTag wordType" v-if="dataItem.datumType === 'WORD'">文档</span>
                                        <span class="datumTypeTag teachingPlanType" v-if="dataItem.datumType === 'TEACHING_PLAN'">教案</span>
                                        <span class="datumTypeTag coursewareType" v-if="dataItem.datumType === 'COURSEWARE'">课件</span>
                                        <span class="datumTypeTag collectionType" v-if="dataItem.datumType === 'COLLECTION'">合集</span>
                                        <span class="datumTypeTag tableType" v-if="dataItem.datumType === 'TABLE'">表格</span>
                                        <span class="datumTypeTag posterType" v-if="dataItem.datumType === 'POSTER'">海报</span>
                                        <span class="datumTypeTag speakType" v-if="dataItem.datumType === 'SPEAK'">话术</span>
                                    </div>
                                    <div class="clearfix" style="margin-top: 9px;">
<!--                                        <i class="fl icon-category icon datumVipLabelIcon marginR8" v-show="dataItem.chargeMode && dataItem.isV"></i>-->

<!--                                        <div class="fr">-->
<!--                                            <span class="font14r red" v-show="!dataItem || !dataItem.chargeMode">免费</span>-->
<!--                                            <span class="font12r red" v-show="dataItem && dataItem.chargeMode">￥</span>-->
<!--                                            <span class="font14r red" v-show="dataItem && dataItem.chargeMode">{{dataItem.price}}</span>-->
<!--                                        </div>-->

                                        <!-- 免费 -->
                                        <span class="red" v-if="dataItem.chargeMode==0">免费</span>

                                        <!-- 收费 -->
                                        <template v-else>

                                            <!-- 会员课程 -->
                                            <template v-if="dataItem.isV">
                                                <!-- 会员课程已购买会员 -->
                                                <template v-if="userInstance && userInstance.isContentHasVipPrivilege('datum')">
                                                    <span class="grey deleteLine font14r">原价￥{{dataItem.price}}</span>
                                                    <span class="marginL8 red">免费</span>
                                                </template>

                                                <!-- 会员课程未购买会员 -->
                                                <template v-else="">
                                                    <i class="fl icon-category icon datumVipLabelIcon marginR8"></i>
                                                    <span class=" marginL8 red">￥{{dataItem.price}}</span>
                                                </template>
                                            </template>

                                            <!-- 非会员课程 -->
                                            <template v-else="">
                                                <span class=" marginL8" v-if="dataItem.isPay">￥0.0</span><!-- 已购买 -->
                                                <span class=" marginL8 red" v-else>￥{{dataItem.price}}</span><!-- 未购买 -->
                                            </template>
                                        </template>

                                    </div>
                                </div>
                            </div>
                            <div class="flexLayout marginT8 grey60 font12r">

                                <div class="flexItem" style="padding-left: 6px">
                                    格式：
                                    <span v-if="isHasDatumType(dataItem, 'WORD')">Word</span>
                                    <span v-else-if="isHasDatumType(dataItem, 'PDF')">Pdf</span>
                                    <span v-else-if="isHasDatumType(dataItem, 'PPT')">PPT</span>
                                    <span v-else-if="isHasDatumType(dataItem, 'IMAGE_TEXT')">图文</span>
                                    <span v-else-if="isHasDatumType(dataItem, 'TEACHING_PLAN')">教案</span>
                                    <span v-else-if="isHasDatumType(dataItem, 'MUSIC')">音乐</span>
                                    <span v-else-if="isHasDatumType(dataItem, 'VIDEO')">视频</span>
                                    <span v-else-if="isHasDatumType(dataItem, 'ZIP')">压缩包</span>
                                    <span v-else>{{dataItem.datumType}}</span>
                                </div>
<!--                                <div class="flexItem alignCenter">-->
<!--                                    {{dataItem.pv + dataItem.pvSham}}浏览量-->
<!--                                </div>-->
<!--                                <div class="flexItem alignRight">-->
<!--                                    &lt;!&ndash; 接口写错了，就是 dowmCount &ndash;&gt;-->
<!--                                    {{dataItem.dowmCount}}下载量-->
<!--                                </div>-->
                            </div>
                            <div v-if="isDebug && dataItem.isPay" class="">
                                (已购买)
                            </div>
                        </div><!-- end .datumItem -->

                        <div class="paddingV16 alignCenter font14r colorCCC"
                             v-show="status==='ready' && pagination.current == pagination.totalPage"
                             :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                            没有更多资料了
                        </div>

                    </div><!-- end .datumList -->

                    <div class="alignCenter paddingV8" v-show="status === 'loading'">
                        <i class="icon spinner-loader"></i>
                    </div>

                    <div class="paddingV16 alignCenter font14r colorCCC"
                         v-show="status==='ready' && dataList.length < 1">
                        <img src="datum/no_any_datum_206x143.png" width="206" height="143">
                        <br/>
                        <button class="button yellowHollowButton marginT24" style="width: auto"
                                @click="filterOther()">去筛选其他资料</button>
                    </div>

                    <div class="" style="margin-top: 12px; margin-bottom: 32px;"
                         v-show="status==='ready' && pagination.current < pagination.totalPage"
                         @click="loadNextPage()" >
                        <img class="block loadMoreButton" src="button/loadMoreButton.png" width="100%" height="auto"/>
                    </div>

                    <div style="height: 30px;"></div>


                </div>
            </div>
        </div>

    </div>
</template>

<script>

import generalCmpPart from '@/components/part/generalCmpPart';

// config
import appConfig from '../../appConfig';

// data
import externalApp from '@data/externalApp';

// modules
import datumModule from './datumModule.vue';
import datumFilterDrawer from '@comp/drawer/datumFilterDrawer';
import fixedBottomVipBar from '@comp/vip/fixedBottomVipBar';

// utils
import consoleHelper from '@util/consoleHelper';
import appHelper from '@util/appHelper';
import categorySidebar from "@comp/datum/categorySidebar";
import windowHelper from "@util/windowHelper";
import arrayHelper from "@util/arrayHelper";
import adTypeEnum from "@comp/ad/adTypeEnum";
import {toDetailByBizType} from "@comp/shixunApp/toDetail";
import userUtil from "@comp/shixunApp/userUtil";

const config = {
    apiConfig : {
        list : {
            url : 'portal/datum/list',
            params : {}
        }
    }
};

export default {
    name: "datum",
    extends : generalCmpPart,
    components : {
        categorySidebar
    },
    data () {
        return {
            title : '师讯·资料',
            sortTypeList : [{
                type : '',
                title : '全部',
                discriminateDirection : false
            }
            // , {
            //     type : 'pv',
            //     title : '浏览量',
            //     discriminateDirection : true
            // },{
            //     type : 'dowm_count',
            //     title : '下载量',
            //     discriminateDirection : true
            // }
            ,{
                type : 'create_time',
                title : '最新',
                discriminateDirection : true
            }],
            /**
             * @type    {{null|Object}}
             */
            selectedSortType : null,

            apiConfig : config.apiConfig,
            enableDataList : true,      // 开启 dataList 功能
            autoLoadDataList : appConfig.mode !== 'demo',
            mode : appConfig.mode,
            scrollToLoadNextPage : false,    // 无限拖动加载
            pageSize : 15,
            externalApp : externalApp,

            advanceFilter : false,
            filterCategoryTitle : '',

            isDebug : consoleHelper.getDebugStatus(),

            showChoicenessDatum : true,

            height : 0,
            header : {
                height : 44
            },
            adTypeEnum : adTypeEnum,

            toDetailByBizType:toDetailByBizType,

            debug : consoleHelper.getDebugStatus(),

            searchInputbox : {
                column : 'title'
            },

            filters : {
                // firstCategory : '',
                // secondCategory : '',
                tagList : '',
            },

            userData : null,
            userInstance : null,
        }
    },
    methods : {
        view : function (item) {
            // let url = externalApp.oldShixun.baseUrl + 'html/downloadDetail.html?id=' + item.id;
            // appHelper.redirect(url);
            appHelper.goToPage('datumDetail', {
                id : item.id
            });
        },

        setContainerHeight() {
            let h = windowHelper.getHeight();
            this.height = h - this.header.height;
        },

        viewItem(dataItem) {
            appHelper.goToPage('datumDetail', {
                id : dataItem.id
            });
        },

        onChangeCategory(result) {

            // this.filters.firstCategory = result.firstCategory || '';
            // this.filters.secondCategory = result.secondCategory || '';
            let tag = '';
            result.firstCategory ? tag = result.firstCategory : null;
            result.secondCategory ? tag = result.secondCategory : null;
            this.filters.tagList = tag;

            this.reloadDataList();
        },

        /**
         * @param   {Object}    sortItem
         */
        selectSortType(sortItem) {
            this.selectedSortType = sortItem;
            this.filters.orderBy = sortItem.type;
            if (sortItem.type)
            {
                this.showChoicenessDatum = false;
            }
            else
            {
                this.showChoicenessDatum = true;
            }
            this.reloadDataList();
        },

        /**
         * @param   {Array} tagList
         */
        onChangeFilter(data) {

            let typeList            = data.typeList;
            let firstCategory       = data.firstCategory;
            let secondCategoryList  = data.secondCategoryList;

            // activate advance filter status
            this.advanceFilter = true;

            // build request param 'tagList'
            let ids = [];
            for (let i=0; i<typeList.length; i++)
            {
                ids.push(typeList[i].id);
            }
            if (secondCategoryList.length)  // add second category list or first category
            {
                for (let i=0; i<secondCategoryList.length; i++)
                {
                    ids.push(secondCategoryList[i].id);
                }
            }
            else
            {
                firstCategory ? ids.push(firstCategory.id) : null;
            }
            // update request options
            this.filters.tagList = ids.join(',');

            // set filter title
            this.filterCategoryTitle = firstCategory ? firstCategory.title : '';

            // reset sort type
            this.selectSortType(this.sortTypeList[0]);

            // hidden choiceness datum module
            this.showChoicenessDatum = false;

            this.reloadDataList();
        },

        onResetFilter() {

            this.advanceFilter = false;

            // reset sort type
            this.selectedSortType = this.sortTypeList[0];
            this.filters.orderBy = '';

            // reset filter title
            this.filterCategoryTitle = '';

            // show choiceness datum module
            this.showChoicenessDatum = true;

            this.filters.tagList = '';
            this.reloadDataList();
        },

        isShowChoicenessDatumModule() {
            // 全部的时候才显示，其他排序状态不显示
            if (this.selectedSortType === this.sortTypeList[0])
            {
                return true;
            }
            return false;
        },

        filterOther() {
            this.$refs.datumFilterDrawer.open();
        },

        isHasDatumType(dataItem, type = '') {
            let datumTypeString = dataItem.datumType || '';
            let list = datumTypeString.split(',');
            return arrayHelper.existElement(type, list);
        }
    },
    mounted() {
        this.selectedSortType = this.sortTypeList[0];

        const me = this;

        if (typeof(window) === 'object')
        {
            window.addEventListener('resize', () => {

                if (!me)
                {
                    return;
                }
                me.setContainerHeight();
            });
            me.setContainerHeight();
        }

        appHelper.checkLogin((error, result) => {

            if (error)
            {
                return;
            }
            if (result)
            {
                this.userData = result;
                this.userInstance = userUtil.createUser(result);
            }
            else {
                this.setWechatShare();
            }
        });
    }
}
</script>

<style lang="scss" scoped>

.filterArea {
    //position: fixed;
    //z-index: 1;
    //top: 44px;
    ////top: 0;
    //left: 0;
    //width: 100%;
    //height: 52px;

    .sortItem {
        float: left;
        margin-right: 20px;
        line-height: 24px;
        font-size: 14px;

        color: #8994A9;

        .triangleIcon {
            width: 5px;
            height: 4px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAAgUlEQVQYlYXNwQnCQBSE4QlpRFtJMSkl61uPO8QSNjsNeLIGwQoEmwjk8DyF5LDGH+b0Pngw6m4sfrQL9UCk3v+gUR+EpM5YlgO4hKQOAGCj4k84KmJNUmssz8rLl6QW+8ItnyI1ryhS8zXpjFqRU7/Bqa8iAHD3xpgHYx7cvdnfvhAanaJimXA2AAAAAElFTkSuQmCC');
            float: right;
            position: relative;
            top: 10px;
            margin-left: 4px;
        }

        &.active {
            font-size: 16px;
            font-weight: bold;
            color: #333;

            .triangleIcon {
                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAAdUlEQVQYlYXMsQnDQBBE0RFqxG7hz3IoVg/bgkpRoIYUuQaDKzC4CYECO7HggkP6MNE+VsBq+3uxh2y/r2BEfASMtvcTuAOjJCkilpNvi44ys7f9bMBXZvaqG4bhBmwHArZSyl2tgKmCUxP962zPtmdJXX34Abq3U9Y/Jml4AAAAAElFTkSuQmCC');
            }
        }
        &:last-child {
            margin-right: 0;
        }
    }
    .advancedFilterButton{
        position: relative;
        width: 80px;
        height: 24px;
        line-height: 24px;
        padding: 0;
        background: #F2F3F8;
        border-radius: 4px;

        font-size: 16px;
        font-weight: bolder;
        color: #333333;

        border: none;

        &:after {
            content : '';
            display : inline-block;
            position: absolute;
            bottom: 2px;
            right: 3px;

            width: 5px;
            height: 6px;
            background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAAhklEQVQokdXPoQ3CUBSG0RfCBAiWIKm451XUdQwSDBOwCigmwGAwGBLwTIFgiOpiKih5qeez94j/plSorutVRFSl26imaRZ44TgJ27ad55zv6PGcxDgMsEeXUpoVYc55/QV79MXdCHQFvB3BqqqWeP/CAe9HOCI2EfHADVdccMYJu8kn/6APiG42mKQvJYkAAAAASUVORK5CYII=');
            background-size: 100% 100%;
        }
        &.active {
            background: #FFF2DE;
            color: #FFA724;
            &:after {
                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAAAXNSR0IArs4c6QAAAItJREFUKBVjYMAC/i9VMABhdCkmdIH/6xUEGBhZ5jMwMiegy7GgCzB8Z9nAwMhgwPCf8SO6HIrJ/5cpTwAqtAcrgtFIOuCK/y9XTmBgZMxHkmNAdzdYMVjwP0M/skIwm4kZxZNMYA8xMa8HmiqAofg/0O1IgIXhO7MDAwPjQ6AYCKMCRsYPqAJDjwcApI4djd+UkuQAAAAASUVORK5CYII=');
            }
        }
    }
}

.datum_price{
    margin-top: 12px;
    font-size: 16px;

    font-weight: 500;
    color: #FC3439;
}

.icon-category{
    width: 53px;
    height: 16px;
}

.datumListContent {
    .header {

        .title {
            position: relative;
            padding-left: 8px;
            line-height: 22px;
            &:before {
                display: block;
                content: '';

                width:4px;
                height:14px;
                background:linear-gradient(90deg,rgba(246,108,83,1) 0%,rgba(236,76,72,1) 100%);
                border-radius:2px;

                position: absolute;
                z-index: 1;
                left: 0;
                top: 4px;
            }
        }
    }

    .datumItem {
        padding: 16px 0 16px;
    }
}
.searchButtonArea.fixed {
    position: fixed;
    z-index: 5;
    right: 20px;
    bottom: 100px;
}
.yellowHollowButton {
    height: 30px;
    padding: 0 14px;
    background: #FFFFFF;
    border: 1px solid #FFA724;
    box-sizing: border-box;
    border-radius: 16px;

    font-size: 14px;
    line-height: 30px;
    color: #FFA724;
}
.deleteLine {
    text-decoration: line-through;
}

.datumTypeTag {
    display: inline-block;
    padding: 2px 4px;
    border-radius: 4px;
    margin-left: 9px;
    color: white;
    background: #000;
    font-size: 12px;
}
.datumTypeTag.wordType {
    background: #FE5747;
}
.datumTypeTag.coursewareType {
    background: #FFCE00;
}
.datumTypeTag.teachingPlanType {
    background: #779F10;
}
.datumTypeTag.collectionType {
    background: #FD9903;
}
.datumTypeTag.environmentCreativeType {
    background: #00A9F7;
}
.datumTypeTag.speakType {
    background: #B3EE18;
}
.datumTypeTag.tableType {
    background: #077938;
}
.datumTypeTag.posterType {
    background: #EF6EF9;
}
</style>

